(function () {
  function initCarousel(root) {
    if (root.dataset.scInit) return;
    root.dataset.scInit = 'true';

    var track = root.querySelector('.sc-carousel__track');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    if (!slides.length) return;

    var viewport = root.querySelector('.sc-carousel__viewport');
    var prevBtn = root.querySelector('.sc-carousel__arrow--prev');
    var nextBtn = root.querySelector('.sc-carousel__arrow--next');
    var mode = root.dataset.mode;
    var direction = root.dataset.direction;
    var speed = parseFloat(root.dataset.speed) || 3;
    var fluid = mode === 'autoplay' && root.dataset.fluid === 'true';

    function gap() {
      return parseFloat(getComputedStyle(track).columnGap) || 0;
    }

    function slideStep() {
      return slides[0].getBoundingClientRect().width + gap();
    }

    if (fluid) {
      initFluidMarquee();
    } else {
      initSteppedCarousel();
    }

    // Continuous, non-stop marquee: clones the slide set once so the track
    // can be looped seamlessly, and moves it every frame instead of jumping.
    function initFluidMarquee() {
      slides.forEach(function (slide) {
        var clone = slide.cloneNode(true);
        clone.removeAttribute('id');
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });
      track.style.transition = 'none';

      var setWidth = 0;
      function measureSetWidth() {
        setWidth = 0;
        for (var i = 0; i < slides.length; i++) {
          setWidth += slides[i].getBoundingClientRect().width + gap();
        }
      }
      measureSetWidth();

      var offset = 0;
      var lastTime = null;
      var paused = false;

      function pxPerSecond() {
        return slideStep() / Math.max(0.2, speed);
      }

      function frame(time) {
        if (lastTime === null) lastTime = time;
        var dt = (time - lastTime) / 1000;
        lastTime = time;
        if (!paused && setWidth > 0) {
          var delta = pxPerSecond() * dt;
          if (direction === 'right') {
            offset -= delta;
            if (offset < 0) offset += setWidth;
          } else {
            offset += delta;
            if (offset >= setWidth) offset -= setWidth;
          }
          track.style.transform = 'translateX(' + -offset + 'px)';
        }
        requestAnimationFrame(frame);
      }

      root.addEventListener('mouseenter', function () {
        paused = true;
      });
      root.addEventListener('mouseleave', function () {
        paused = false;
        lastTime = null;
      });
      window.addEventListener('resize', measureSetWidth);

      requestAnimationFrame(frame);
    }

    // Discrete carousel: one slide-width jump per tick/click, with
    // autoplay, arrows and drag/swipe support.
    function initSteppedCarousel() {
      var index = 0;
      var timer = null;
      var isDown = false;
      var startX = 0;
      var startTranslate = 0;

      function maxIndex() {
        var step = slideStep();
        if (!step) return 0;
        var visible = Math.max(1, Math.round(viewport.clientWidth / step));
        return Math.max(0, slides.length - visible);
      }

      function goTo(i) {
        var max = maxIndex();
        if (i < 0) i = max;
        if (i > max) i = 0;
        index = i;
        track.style.transform = 'translateX(' + -(index * slideStep()) + 'px)';
      }

      function next() {
        goTo(index + 1);
      }

      function prev() {
        goTo(index - 1);
      }

      function tick() {
        if (direction === 'right') {
          prev();
        } else {
          next();
        }
      }

      function startAutoplay() {
        if (mode !== 'autoplay' || slides.length < 2) return;
        stopAutoplay();
        timer = setInterval(tick, Math.max(0.5, speed) * 1000);
      }

      function stopAutoplay() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      function resetAutoplay() {
        stopAutoplay();
        startAutoplay();
      }

      function getTranslate() {
        var style = getComputedStyle(track).transform;
        if (style === 'none') return 0;
        var match = style.match(/matrix\(([^)]+)\)/);
        if (!match) return 0;
        return parseFloat(match[1].split(',')[4]) || 0;
      }

      function pointerX(e) {
        return e.touches ? e.touches[0].clientX : e.clientX;
      }

      function pointerDown(e) {
        isDown = true;
        startX = pointerX(e);
        startTranslate = getTranslate();
        track.style.transition = 'none';
        stopAutoplay();
      }

      function pointerMove(e) {
        if (!isDown) return;
        var delta = pointerX(e) - startX;
        track.style.transform = 'translateX(' + (startTranslate + delta) + 'px)';
      }

      function pointerUp(e) {
        if (!isDown) return;
        isDown = false;
        track.style.transition = '';
        var endX = e.changedTouches ? e.changedTouches[0].clientX : e.clientX;
        var delta = endX - startX;
        var step = slideStep();
        if (Math.abs(delta) > step / 4) {
          if (delta < 0) {
            next();
          } else {
            prev();
          }
        } else {
          goTo(index);
        }
        resetAutoplay();
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          prev();
          resetAutoplay();
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          next();
          resetAutoplay();
        });
      }

      track.addEventListener('mousedown', pointerDown);
      track.addEventListener('touchstart', pointerDown, { passive: true });
      window.addEventListener('mousemove', pointerMove);
      track.addEventListener('touchmove', pointerMove, { passive: true });
      window.addEventListener('mouseup', pointerUp);
      track.addEventListener('touchend', pointerUp);

      root.addEventListener('mouseenter', stopAutoplay);
      root.addEventListener('mouseleave', resetAutoplay);

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          goTo(index);
        }, 150);
      });

      goTo(0);
      startAutoplay();
    }
  }

  function initAll(context) {
    (context || document).querySelectorAll('[data-sc-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
